import {CommonModule} from '@angular/common';
import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {LinkModule} from '@aztrix/components/link';
import {HelperPipesModule} from '@aztrix/helpers';
import {IconsModule} from '@aztrix/icons';
import {
  AgreementDataRepresentation,
  AgreementRepresentation,
  ProposalRepresentation,
} from '@aztrix/sdk';
import {TranslatePipe} from '@aztrix/translate';
import {combineLatest, map, Observable, ReplaySubject} from 'rxjs';

@Component({
  selector: 'ax-agreement-history-action',
  templateUrl: './agreement-history-action.component.html',
  styleUrls: ['./agreement-history-action.component.scss'],
  standalone: true,
  imports: [CommonModule, LinkModule, HelperPipesModule, TranslatePipe, IconsModule],
})
export class AgreementHistoryActionComponent implements OnChanges {
  @Input() proposal?: ProposalRepresentation;
  @Input() agreement?: AgreementRepresentation;
  @Input() agreementData?: AgreementDataRepresentation;
  @Input() historyData: AgreementDataRepresentation[];
  @Input() isExternal = false;

  private _agreement$ = new ReplaySubject<AgreementRepresentation>(1);
  private _agreementData$ = new ReplaySubject<AgreementDataRepresentation>(1);

  isHistoryAgreement$: Observable<boolean> = combineLatest([
    this._agreementData$,
    this._agreement$,
  ]).pipe(
    map(
      ([agreementData, agreement]) =>
        agreementData.startTimestamp !== agreement?.agreementData?.startTimestamp
    )
  );

  canViewHistory$: Observable<boolean> = combineLatest([
    this._agreementData$,
    this._agreement$,
  ]).pipe(map(([agreementData, agreement]) => !!agreementData || !!agreement.expirationTimestamp));

  ngOnChanges(changes: SimpleChanges) {
    if (this.agreement && changes.agreement) {
      this._agreement$.next(this.agreement);
    }

    if (this.agreementData && changes.agreementData) {
      this._agreementData$.next(this.agreementData);
    }
  }
}
